import { SearchComponent } from "../components/searchComponent"

export const CasesPage = () => {
  document.title = "CAS"
  return (<SearchComponent page="cas" />)
}